module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-panel padded"
  }, [_vm._m(0), _vm._v(" "), _c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.getInvoices
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "btn light wide ml-auto mb-3"
  }, [_c('i', {
    staticClass: "ico-add color-1"
  }), _vm._v("\n            New invoice\n        ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-03ab73ba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ab73ba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/view/ViewInvoices.vue
// module id = 2197
// module chunks = 0